import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { api } from '@/lib/api';
import snapshot from './catalogSnapshot.json';
import { consistentCatalog } from './catalogSafety';

const CatalogContext = createContext(null);
const DraftContext = createContext(null);
export const SignalProvider = ({children}) => {
  const [catalog, setCatalog] = useState({...snapshot, error: false, checking: true});
  const [draft, setDraft] = useState({name: '', email: '', task: '', tools: '', hp_field: ''});
  const [agreement, setAgreement] = useState('new');
  const [intent, setIntent] = useState(null);
  const [receipt, setReceipt] = useState(null);
  const requestId = useRef(0);
  const refresh = useCallback(async () => {
    const current = ++requestId.current;
    setCatalog(c => ({...c, checking: true}));
    try {
      const [config, prices] = await Promise.all([api.get('/automation-center/config'), api.get('/automation-center/package-pricing')]);
      const pair = consistentCatalog(config.data, prices.data);
      if (current === requestId.current) setCatalog({...pair, error: false, checking: false});
    } catch (e) {
      if (current === requestId.current) setCatalog(c => ({...c, error: true, checking: false, errorKind: e.message}));
    }
  }, []);
  useEffect(() => { refresh(); return () => { requestId.current++; }; }, [refresh]);
  return <CatalogContext.Provider value={{...catalog, refresh}}><DraftContext.Provider value={{draft, setDraft, intent, setIntent, receipt, setReceipt, agreement, setAgreement}}>{children}</DraftContext.Provider></CatalogContext.Provider>;
};
export const useCatalog = () => useContext(CatalogContext);
export const useInquiryDraft = () => useContext(DraftContext);